import { Injectable } from "@angular/core";

@Injectable() export class Globals {

    public loading: boolean = false;
    public error: string;
    public info: string;
    public appId: string = "MXBCOM";
    public cookieName: string = "cookie_MXBCOM";
    public uoauth: string = "ea75016c-42be-4c97-a68d-a7532b21086b";
    public poauth: string = "ZAEZxyl#LnIo4=I92D{X|MA02OY|ui";
    public busquedaBinEM: any;
    public busquedaBinAD: any;
    public busquedaBinEG: any;
    public busquedaBinBA: any;
    public busquedaBinBX: any;
    public busquedaBinMC: any;

    public timeoutToast = 7000;

    public optionsByPickerdate: Pickadate.DateOptions = {
        monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        weekdaysShort: ['Dom', 'Lun',  'Mar', 'Mie','Jue', 'Vie', 'Sab'],
        weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
        clear: 'Limpiar',
        close: 'Aceptar', 
        today: 'Hoy',
        selectYears: true,
        closeOnClear: true,
        closeOnSelect: false,
        format: 'dddd, dd mmm, yyyy',
        formatSubmit: 'yyyy-mm-dd',
        selectMonths: true
      };
  
}
 
